<template>
  <div>
      11111
  </div>
</template>

<script>
export default {
  name: "maintenanceRecord"
}
</script>

<style scoped>

</style>